import { STEPS_PER_ROUND, type SpentStep } from "../../shared/domain.ts";

/**
 * One row per Step. Verdict colour is never the only signal — each row carries
 * a label too, so the game works without colour vision.
 */
export function GuessRows({
  spent,
  titleFor,
}: {
  spent: SpentStep[];
  titleFor: (trackId: number) => string;
}) {
  return (
    <ol className="rows" aria-label="Your guesses">
      {Array.from({ length: STEPS_PER_ROUND }, (_, i) => {
        const step = spent[i];

        if (!step) {
          return <li key={i} className="row row--empty" aria-label={`Step ${i + 1}, unused`} />;
        }

        if (step.verdict === "skipped") {
          return (
            <li key={i} className="row row--skipped">
              <span className="row__mark" aria-hidden="true">
                ⤳
              </span>
              <span className="row__text">Skipped</span>
            </li>
          );
        }

        return (
          <li key={i} className={`row row--${step.verdict}`}>
            <span className="row__mark" aria-hidden="true">
              {step.verdict === "exact" ? "✓" : step.verdict === "artist-match" ? "◐" : "✕"}
            </span>
            <span className="row__text">{titleFor(step.guessedTrackId!)}</span>
            <span className="row__tag">
              {step.verdict === "exact"
                ? "Correct"
                : step.verdict === "artist-match"
                  ? "Right artist"
                  : "Wrong"}
            </span>
          </li>
        );
      })}
    </ol>
  );
}
